///<amd-dependency path="jQueryUI/droppable"/>
///<reference types="jquery" />
import * as Service from "VSS/Service";
import { WebPageDataService } from "VSS/Contributions/Services";

export const BACKLOGPERMISSION_DATAPROVIDER_ID: string = "ms.vss-work-web.backlog-permission-data-provider";

export interface IAdvanceBacklogManagementPermission {
    hasPermission: boolean
}

export function hasAgileToolsBacklogManagementPermission(): boolean {
    const pageDataService = Service.getService(WebPageDataService);
    let permissionData = pageDataService.getPageData<IAdvanceBacklogManagementPermission>(BACKLOGPERMISSION_DATAPROVIDER_ID);
    return !!permissionData ? permissionData.hasPermission : false;
}
